import react from 'react'
import './index.css';
import loader from "./loader.json";
import loaderBlue from "./progress_blue.json";
import Lottie from "lottie-react";

export default function LoaderLulo({type = 'v1'}) {
    return (
        <div style={{width: 50}}>
            <Lottie speed={1.5} width={20} height={20} animationData={type === 'v1' ? loader : loaderBlue} />
        </div>
    )
}
